import top_menu from "./top"
import home from "./home"
import free from "./new_free"
import privacy from "./new_privacy"
import extension from "./new_extension"
import download from "./new_download"
import place from "./new_place"
import problem from "./new_problem"
import legal from "./new_legal"
import bottom from "./bottom"
import purchase from "./new_purchase"

let language = [
  {
    value: "zh",
    label: "中文",
  },
  {
    value: "en",
    label: "英文",
  },
]
export default {
  language,
  top_menu,
  home,
  free,
  privacy,
  extension,
  download,
  place,
  problem,
  legal,
  bottom,
  purchase
 }


// WEBPACK FOOTER //
// ./src/assets/lang/zh/index.js